import axios from "axios";
import { logout } from "../stores/auth";
import store from "../stores";


export const APIControl = (basePath) => {
  const instance = axios.create({
    baseURL: basePath,
  });

  instance.interceptors.response.use(
    (response) => {
        
      return response;
    },
    (error) => {
       
      if (error.response && error.response.status === 498) {
        store.dispatch(logout());
        window.location.href = "/auth/login";
        return;
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
